import { createRouter, RouterProvider } from "@tanstack/react-router";
import { MsalAuthProvider } from "@/components/MsalAuthProvider";
import { queryClient } from "@/lib/queryClient";
import { routeTree } from "./routeTree";

const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  context: { queryClient },
});

// Register the router for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export function App() {
  return (
    <MsalAuthProvider>
      <RouterProvider router={router} />
    </MsalAuthProvider>
  );
}
